<script setup lang="ts">
import HeaderComponent from '@/components/HeaderComponent.vue'
import { useContactStore } from '@/store/contact.store'
import ContactFormCard from '@/components/contact/ContactFormCard.vue'

const store = useContactStore()
const hero = store.getHeader
</script>

<template>
  <HeaderComponent
    v-if="hero"
    :title="hero.title"
    :describe="hero.copy"
    :background="hero.background"
  >
    <ContactFormCard />
  </HeaderComponent>
</template>
